export const charactersMessages = {
  title: 'My Characters',
  createButton: 'Create New Character',
  notImplementedAlert: 'Not implemented yet',
  loading: 'Loading characters...',
  errorLoading: 'Failed to load characters. Please try again.',
  noCharactersFound: 'No characters found',
  noCharactersDescription: 'Create your first character to get started!',
  deleteAction: 'Delete',
  deleting: 'Deleting...',
  deleteSuccessMessage: 'Character deleted successfully!',
  deleteErrorMessage: 'Failed to delete character. Please try again.',
  deleteConfirmTitle: 'Delete Character',
  deleteConfirmMessage:
    'Are you sure you want to delete this character? This action cannot be undone.',
} as const;
